import { render, staticRenderFns } from "./ModalSales.vue?vue&type=template&id=6480b997&lang=pug&"
import script from "./ModalSales.vue?vue&type=script&lang=js&"
export * from "./ModalSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports